import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import styles from './Pubslish.module.css';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
  p: 2,
  borderRadius: '12px', // 👈 Add this line
};

export default function CreateNew({ setOpen, open, newCategoryName, setNewCategoryName, handleSubmit }) {
  const handleClose = () => setOpen(false);
  const createCategory = (e) => {
    setNewCategoryName(e);
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <p className={styles.createx}>Create new Category</p>
          <div className={styles.cetrnx}>
            <label className={styles.titlex} htmlFor="">
              Title
            </label>
            <input
              className={styles.inputbxo}
              type="text"
              value={newCategoryName}
              placeholder="Enter Category"
              onChange={(e) => createCategory(e.target.value)}
            />
          </div>
          <div className={styles.flexbut}>
            <button className={styles.eachButtonTocreate} onClick={handleClose}>
              Cancel
            </button>
            <button
              // disabled={!newCategoryName}
                onClick={handleSubmit}
              className={styles.eachCrtee}
            >
              Create
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
